module.exports = "<app-carrousel></app-carrousel>\r\n<app-tile-we></app-tile-we>\r\n<app-tile-make></app-tile-make>\r\n<app-tile-create></app-tile-create>"